import React from "react";
import {
  Shield,
  AlertTriangle,
  Scale,
  Info,
  FileText,
  Calendar,
  Globe,
} from "lucide-react";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import Meta from "../components/Meta";

export default function DisclaimerPage() {
  return (
    <>
      <Meta
        title="Disclaimer - Govind Sinha & Co."
        description="As per the rules of the ICAI regulations for Chartered Accountants, firms/LLPs are not permitted to solicit work and advertise. By accessing this website (cagovindsinha.com) the user fully accepts that you are seeking information of your own accord and volition and that no form of solicitation has taken place by the firm/LLP or its members."
        canonical="https://cagovindsinha.com/disclaimer"
      />
      <div className="min-h-screen pt-16 bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100">
        <Navbar />
        <div className="max-w-4xl px-6 py-12 mx-auto">
          {/* Single Content Card */}
          <div className="p-8 transition-all duration-300 border shadow-xl bg-white/80 backdrop-blur-sm rounded-2xl border-slate-200/50 hover:shadow-2xl">
            {/* Introduction */}
            <div className="flex items-start mb-8 space-x-4">
              <div className="p-3 rounded-full bg-amber-100">
                <AlertTriangle className="w-6 h-6 text-amber-600" />
              </div>
              <div>
                <h1 className="mb-4 text-3xl font-bold text-transparent bg-gradient-to-r from-amber-600 to-orange-600 bg-clip-text">
                  Disclaimer
                </h1>
                <p className="mb-4 leading-relaxed text-slate-600">
                  Please read this disclaimer carefully before using our
                  website. By accessing and using cagovindsinha.com, you
                  acknowledge that you have read, understood, and agree to be
                  bound by the terms of this disclaimer.
                </p>
                <div className="flex items-center mt-4 space-x-4 text-sm text-slate-500">
                  <div className="flex items-center space-x-1">
                    <Calendar className="w-4 h-4" />
                    <span>Last updated: July 2025</span>
                  </div>
                  <div className="flex items-center space-x-1">
                    <Globe className="w-4 h-4" />
                    <span>cagovindsinha.com</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="pt-8 border-t border-slate-200">
              {/* ICAI Regulations Notice */}
              <div className="mb-8">
                <div className="flex items-start space-x-4">
                  <div className="p-2 bg-blue-100 rounded-lg">
                    <Scale className="w-5 h-5 text-blue-600" />
                  </div>
                  <div>
                    <h3 className="mb-3 text-lg font-semibold text-slate-800">
                      Professional Regulations
                    </h3>
                    <div className="space-y-4 leading-relaxed text-slate-600">
                      <p>
                        As per the rules of the ICAI regulations for Chartered
                        Accountants, firms/LLPs are not permitted to solicit
                        work and advertise. By accessing this website
                        (cagovindsinha.com) the user fully accepts that you are
                        seeking information of your own accord and volition and
                        that no form of solicitation has taken place by the
                        firm/LLP or its members.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Information Purpose */}
              <div className="mb-8">
                <div className="flex items-start space-x-4">
                  <div className="p-2 bg-green-100 rounded-lg">
                    <Info className="w-5 h-5 text-green-600" />
                  </div>
                  <div>
                    <h3 className="mb-3 text-lg font-semibold text-slate-800">
                      Information Purpose Only
                    </h3>
                    <div className="space-y-4 leading-relaxed text-slate-600">
                      <p>
                        The information provided under this website is solely
                        available at your request for information purposes only.
                        It should not be interpreted as soliciting or
                        advertisement.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Liability Disclaimer */}
              <div className="mb-8">
                <div className="flex items-start space-x-4">
                  <div className="p-2 bg-red-100 rounded-lg">
                    <Shield className="w-5 h-5 text-red-600" />
                  </div>
                  <div>
                    <h3 className="mb-3 text-lg font-semibold text-slate-800">
                      Limitation of Liability
                    </h3>
                    <div className="space-y-4 leading-relaxed text-slate-600">
                      <p>
                        The firm/LLP and its partners or associates are not
                        liable for any consequence of any action taken by the
                        user relying on material / information provided under
                        this website.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Legal Advice Notice */}
              <div className="mb-8">
                <div className="flex items-start space-x-4">
                  <div className="p-2 bg-purple-100 rounded-lg">
                    <FileText className="w-5 h-5 text-purple-600" />
                  </div>
                  <div>
                    <h3 className="mb-3 text-lg font-semibold text-slate-800">
                      Independent Legal Advice
                    </h3>
                    <div className="space-y-4 leading-relaxed text-slate-600">
                      <p>
                        In cases where the user has any legal issues, he/she in
                        all cases must seek independent legal advice.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Additional Important Information */}
              <div className="p-6 mb-8 border bg-amber-50 border-amber-200 rounded-xl">
                <div className="flex items-start space-x-3">
                  <AlertTriangle className="w-5 h-5 text-amber-600 mt-0.5 flex-shrink-0" />
                  <div>
                    <h4 className="mb-2 font-semibold text-amber-800">
                      Important Notice
                    </h4>
                    <p className="text-sm leading-relaxed text-amber-700">
                      By continuing to use this website, you acknowledge that
                      you understand and accept the terms of this disclaimer. If
                      you do not agree with any part of this disclaimer, please
                      discontinue use of this website immediately.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className="mt-8 text-center text-slate-500">
            <p className="text-sm">
              This disclaimer is part of our commitment to professional
              compliance and transparency.
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
